module.exports = __webpack_public_path__ + "img/btn.a212f944.png";